import React, { useContext, memo } from "react";

import { validators } from "components/Form/validators";
import { ISelect, IOption } from "./interface";

import { FailContext } from "components/Form";
import { Column } from "components/Layout/Grid";
import Text from "components/Text";

import { DisableButton } from "utils/DisableButton";

const Select: React.FC<ISelect> = (props) => {
  const {
    name,
    value,
    options,
    required,
    className,
    stateName,
    subjection,
    classNameDiv,
    disabled = false,
    skipSelectOption,
    defaultBlankValue,
    ...rest
  } = props;
  const fail = useContext(FailContext);

  const isValid = () => {
    if (validators.select) {
      return validators.select(value, name, required);
    }
    return true;
  };

  const shouldRenderOption = (option: IOption, index: number) => {
    if (option.show?.length && subjection) {
      if (option.show?.includes(subjection)) {
        return (
          <option key={index} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        );
      }
      return null;
    }

    return (
      <option key={index} value={option.value} disabled={option.disabled}>
        {option.label}
      </option>
    );
  };

  return (
    <Column className={classNameDiv ? classNameDiv : "flex-1 relative "}>
      <select
        {...rest}
        name={name}
        value={value}
        disabled={disabled}
        data-customtype="select"
        required={required || false}
        data-statename={stateName || undefined}
        style={isValid() && fail ? { border: "2px solid tomato" } : {}}
        className={`${className} ${DisableButton(disabled)}`}
      >
        {!skipSelectOption && (
          <option value="" >
            {defaultBlankValue ? 'SELECIONE' : defaultBlankValue}
          </option>
        )}
        {options?.map((option, _) => shouldRenderOption(option, _))}
      </select>
      {isValid() && fail && (
        <Text size={12} className="animated fadeIn mt-1 color-danger">
          {isValid()}
        </Text>
      )}
    </Column>
  );
};

export default memo(Select);
